import { DemoBatchJobDetail } from '@/pages/demo/components/DemoBatchJobDetail';

export const DemoBatchJobDetailPage = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-semibold">배치 OCR Job 상세</h1>
      <p className="text-muted-foreground">단건 배치 job 상태 및 이미지별 OCR 결과</p>
    </div>
    <DemoBatchJobDetail />
  </div>
);
